// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18c7N","clinicsSelect":"styles_clinicsSelect__OzdDS"};